import request from 'ynf-core-engine/request'
import { configHook } from '@utils'

/**
 * @description: 审核
 * @param {Object} params
 * @param {Object} data
 * @param {array} rest
 * @return {Promise}
 */
export async function audit ({ params = {}, data = {}, ...rest } = {}) {
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {
      data: ''
    }
  }
  defaultQuery.params = configHook(params, defaultQuery.params)
  defaultQuery.data = configHook(data, defaultQuery.data)

  try {
    const res = await request({
      url: `${_YPD_SERVICE_}/bill/audit`,
      method: 'post',
      ...defaultQuery,
      ...rest
    })
    return res
  } catch (err) {
    return Promise.reject(err)
  }
}

/**
 * @description: 批量审核
 * @param {Object} params
 * @param {Object} data
 * @param {array} rest
 * @return {Promise}
 */
export async function batchAudit ({ params = {}, data = {}, ...rest } = {}) {
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {
      data: ''
    }
  }
  defaultQuery.params = configHook(params, defaultQuery.params)
  defaultQuery.data = configHook(data, defaultQuery.data)

  try {
    const res = await request({
      url: `${_YPD_SERVICE_}/bill/batchaudit`,
      method: 'post',
      ...defaultQuery,
      ...rest
    })
    return res
  } catch (err) {
    return Promise.reject(err)
  }
}

/**
 * @description: 弃审
 * @param {*} params
 * @param {*} data
 * @param {array} rest
 * @return {*}
 */
export async function unAudit ({ params = {}, data = {}, ...rest } = {}) {
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {
      data: ''
    }
  }
  defaultQuery.params = configHook(params, defaultQuery.params)
  defaultQuery.data = configHook(data, defaultQuery.data)

  try {
    const res = await request({
      url: `${_YPD_SERVICE_}/bill/unaudit`,
      method: 'post',
      ...defaultQuery,
      ...rest
    })
    return res
  } catch (err) {
    return Promise.reject(err)
  }
}

/**
 * @description: 批量弃审
 * @param {Object} params
 * @param {Object} data
 * @param {array} rest
 * @return {Promise}
 */
export async function batchUnAudit ({ params = {}, data = {}, ...rest } = {}) {
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {
      data: ''
    }
  }
  defaultQuery.params = configHook(params, defaultQuery.params)
  defaultQuery.data = configHook(data, defaultQuery.data)

  try {
    const res = await request({
      url: `${_YPD_SERVICE_}/bill/batchunaudit`,
      method: 'post',
      ...defaultQuery,
      ...rest
    })
    return res
  } catch (err) {
    return Promise.reject(err)
  }
}